const ProjectData = [
        {
            id: '1',
            name: 'Pirate Chicks Vintage',
            description: 'A PostgreSQL, Node.js, Express and React E-Commerce Website for my Vintage and Antique Shop, Pirate Chicks Vintage, using the Stripe API',
            link: 'https://github.com/kristenkrofchik/react-cart-pirate-chicks'
        },
        {
            id: '2',
            name: 'History Lesson',
            description: 'A PostgreSQL, Python, Flask, and JavaScript app for teachers to plan and schedule history lessons with resources from the Library of Congress API',
            link: 'https://github.com/kristenkrofchik/history_lesson_capstone'
        },
        {
            id: '3',
            name: 'React Jobly',
            description: 'A React app with a Node.js back end to Register, Search, and Apply for Jobs',
            link: 'https://github.com/kristenkrofchik/react-jobly'
        },
        {
            id: '4',
            name: 'Flask Warbler',
            description: 'A Twitter clone project using Python and Flask',
            link: 'https://github.com/kristenkrofchik/flask_warbler'
        },
        {
            id:'5',
            name: 'Express Biztime',
            description: 'A REST-ful backend API server for a company/invoice tracker using Node.js and Express',
            link: 'https://github.com/kristenkrofchik/express-biztime'
        },
        {
            id: '6',
            name: 'Flask Feedback',
            description: 'A full-stack feedback app made with Python, Flask, Flask WTForms, and the Jinja2 template engine',
            link: 'https://github.com/kristenkrofchik/flask_feedback'
        }
];

export default ProjectData;